<!--
 * @Author: liangsir
 * @Date: 2020-08-31 11:47:18
 * @LastEditors: liangsir
 * @LastEditTime: 2020-08-31 17:53:08
 * @Description:
-->
<template>
  <!--底部导航-->
  <div class="footnavs">
    <div class="footnav" :class="ison == 1 ? 'on' : ''">
      <!-- /trend -->
      <a href="javascript:;">
        <span @click="handleClickPage('/trend', 1)">
          <img :src="
              ison == 1
                ? require('../../assets/images/fot1_act.png')
                : require('../../assets/images/fot1.png')
            " />
        </span>
        <div class="txt">{{ $t("common.footnav1") }}</div>
      </a>
    </div>
    <div class="footnav" :class="ison == 2 ? 'on' : ''">
      <a href="javascript:;">
        <span @click="handleClickPage('/live', 2)">
          <img :src="
              ison == 2
                ? require('../../assets/images/fot2_act.png')
                : require('../../assets/images/fot2.png')
            " />
        </span>
        <div class="txt">{{ $t("common.footnav2") }}</div>
      </a>
    </div>
    <div v-if="!isH5" class="footnav" :class="ison == 3 ? 'on' : ''">
      <a href="javascript:;">
        <span @click="handleClickPage('/member', 3)">
          <img :src="
              ison == 3
                ? require('../../assets/images/fot3_act.png')
                : require('../../assets/images/fot3.png')
            " />
        </span>
        <div class="txt">{{ $t("common.footnav3") }}</div>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      //ison : 1//当前选择的栏目：1,2,3,4

      isH5: false
    };
  },
  props: {
    ison: {
      type: Number,
      default: 1
    },
    isWebview: {
      type: Boolean,
      default: false
    }
  },

  watch: {
    isWebview (val) {
      this.isH5 = val
    }
  },

  mounted () {
    const isWebview = sessionStorage.getItem("isWebview")
    this.isH5 = isWebview
  },
  methods: {
    handleClickPage (route, on) {
      if (this.ison !== on) {
        console.log("this.isWebview:", this.isH5);
        if (this.isH5) {
          if (route === "/live") {
            const token = localStorage.getItem("token")
            const no = localStorage.getItem("no")
            route = `/h5/device?token=${token}&no=${no}`
          }

          return this.$router.push({
            path: route,
            replace: true
          });
        }

        this.$router.push(route);

      }
    }
  }
};
</script>

<style>
.footnavs {
  display: flex;
  width: 100%;
  height: 60px;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.08);
  background: #fff;
  z-index: 2;
  align-items: center;
}
.footnav {
  flex: 1;
  display: block;
  text-align: center;
}

.footnav a {
  display: block;
}

.footnav a span {
  display: block;
  width: 100%;
  height: 18px;
  margin: 0 auto;
  margin-bottom: 6px;
}
.footnav img {
  width: 18px;
  height: 18px;
  vertical-align: top;
}
.footnav .txt {
  font-size: 11px;
  color: #bbb;
  display: block;
  line-height: 1;
}
.footnav.on .txt {
  color: #3a8cf0;
  font-weight: 700;
}
</style>
